import { useNavigate } from "react-router-dom";
import { routes } from "@/app/navigation/routes";
import { useAuth } from "@/app/providers/useAuth";
import styles from "./SettingsLogoutPage.module.css";

export const SettingsLogoutPage = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const onConfirmLogout = () => {
    logout();
    navigate(routes.login, { replace: true });
  };

  return (
    <div className={styles.page}>
      <div className={styles.backdrop} />
      <section className={styles.modal}>
        <h1 className={styles.title}>Logout</h1>
        <p className={styles.message}>Are you sure you want to logout?</p>
        <div className={styles.actions}>
          <button
            type="button"
            className={styles.cancelButton}
            onClick={() => navigate(routes.settingsAccount)}
          >
            Cancel
          </button>
          <button type="button" className={styles.confirmButton} onClick={onConfirmLogout}>
            Yes, Logout
          </button>
        </div>
      </section>
    </div>
  );
};
